import { useCallback, useEffect, useState } from 'react';
import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import PropTypes from 'prop-types';
// material
import {
  Card,
  Table,
  Stack,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  Tabs,
  Tab,
  Grid,
  Dialog,
  DialogTitle,
  Typography,
  IconButton,
  TextField,
  Button,
  DialogContent,
  DialogActions,
  MenuItem
} from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { format } from 'date-fns';
import { useForm } from 'react-hook-form';
import { ReceiveApi } from '../../utils/Apis';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
// import USERLIST from '../../_mocks_/user'; // ⛔️ NOT NEEDED NOW
import BrudCrumbs from '../../components/BreadCrumbs';
import PageTitle from '../../components/PageHeading';
import { fDate } from '../../utils/formatTime';
import { NOT_AVAILABLE } from '../Global/Constants';
import Label from '../../components/Label';
//
// styling
import ReceivableFileToolbar from './ReceivableFileToolbar';
import ReceivableInvoiceToolbar from './ReceivableInvoiceToolbar';
import { StyledTableCell, StyledTableRow } from '../../utils/StyleTable';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import {
  downloadApiData,
  downloadApiDataGet,
  getBankDropdownData,
  getLoanTypeData,
  getMasterListType
} from '../../store/Slice/Global/GlobalSlice';
import { isValidValue, transformToSelectOptions } from '../../utils/CommonFunction';
import { getInvoiceList, getReceiveList } from '../../store/Slice/Receive/ReceiveSlice';
import useReceiveSelector from '../../store/Slice/Receive/ReceiveSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import CustomSelect from '../../components/CustomInput';
import ReceivableDialogRedux from './ReceivableInvoicePaidDialog';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'bankName', label: 'Bank Name', alignRight: false },
  { id: 'id', label: 'File No', alignRight: false },
  { id: 'name', label: 'Borrower Name', alignRight: false },
  { id: 'bankName', label: 'Branch Name', alignRight: false },
  { id: 'created', label: 'Disb Date', alignRight: false },
  { id: 'amount', label: 'Disb Amount', alignRight: false },
  { id: 'loanType', label: 'Loan Product Type', alignRight: false },
  { id: 'invoiceNo', label: 'Invoice No', alignRight: false },
  { id: 'misIsMatch', label: 'Status', alignRight: false },
  { id: '', label: 'ACTION' }
];

const TABLE_HEAD_INVOICE = [
  { id: 'invoiceNo', label: 'Invoice No', alignRight: false },
  { id: 'created', label: 'Invoice Date', alignRight: false },
  { id: 'bankName', label: 'Bank', alignRight: false },
  { id: 'city', label: 'Branch', alignRight: false },
  { id: 'amount', label: 'Net Amount', alignRight: false },
  { id: 'amount', label: 'Total GST', alignRight: false },
  { id: 'amount', label: 'Total Amount', alignRight: false },
  { id: 'name', label: 'Partner NAME', alignRight: false },
  { id: 'created', label: 'Due Date', alignRight: false },
  { id: 'dueDays', label: 'Due Past Dues', alignRight: false },
  { id: 'receivableStatus', label: 'Status', alignRight: false },
  { id: '', label: 'ACTION' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function Receivable() {
  const [page, setPage] = useState(0);
  const [page1, setPage1] = useState(1);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [selectDate, setSelectDate] = useState('2025-12-10'); // for type="date" TextField
  const [filterParameter, setFilterParameter] = useState({
    loanTypeId: null,
    bankId: null,
    branchId: null
  });
  // invoice specific filter model (used by invoice list API)
  const [invoiceFilterParameter, setInvoiceFilterParameter] = useState({
    bankName: null,
    branchName: null,
    status: null,
    fromDate: null,
    toDate: null
  });
  const [fileTypeId, setFileTypeId] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [openPayment, setOpenPayment] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [rowsPerPage] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);

  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { ReceiveListData = [], InvoiceListData = [] } = useReceiveSelector();
  const { LoanTypeDrop, BankDrop } = useGlobalSelector();
  const debouncedSearch = useDebounce(filterName, 600);

  const PaymentMode = ['RTGS', 'NEFT', 'OTHER', 'UPI', 'BANK TRANSFER'];
  const paymentModeOptions = PaymentMode.map((pm) => ({
    label: pm,
    value: pm.replace(/\s+/g, '_').toUpperCase()
  }));

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // Select all for FILE tab
  const handleSelectAllClickFiles = (event) => {
    if (event.target.checked) {
      const newSelecteds = ReceiveListData?.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // Select all for INVOICE tab
  const handleSelectAllClickInvoices = (event) => {
    if (event.target.checked) {
      const newSelecteds = InvoiceListData?.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleInvoiceDownload = async (invoiceId) => {
    const credentials = {
      invoiceId
    };
    try {
      const result = await dispatch(
        downloadApiDataGet(`${ReceiveApi?.invoiceDownload}/${invoiceId}`, credentials)
      );

      if (result?.success && result?.data) {
        const fileName = `Invoice_${invoiceId}_${format(new Date(), 'dd-MM-yyyy_HH-mm-ss')}.pdf`;

        const url = window.URL.createObjectURL(result.data);
        setPreviewUrl(url);
        setOpenPreview(true);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Download failed:', result.error);
      }
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  const emptyRowsFiles =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ReceiveListData.length) : 0;
  const emptyRowsInvoice =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - InvoiceListData.length) : 0;

  const handleClick = (event, row) => {
    const selectedIndex = selected.indexOf(row);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // ---------------- FILE LIST API (already working) ----------------
  const getReceiveListApi = useCallback(() => {
    if (!fileTypeId || !LoginData) return;

    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      entityListRequestModel: {
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        pageSize: rowsPerPage,
        sortOrder: order,
        pageNumber: page + 1
      },
      filterModel: {
        bankId: filterParameter?.bankId || null,
        branchId: filterParameter?.branchId || null,
        loanTypeId: filterParameter?.loanTypeId || null
      },
      revenueFileStatusId: fileTypeId
    };

    dispatch(getReceiveList(credentials));
  }, [
    LoginData,
    debouncedSearch,
    order,
    rowsPerPage,
    filterParameter,
    fileTypeId,
    dispatch,
    order,
    page,
    rowsPerPage
  ]);

  // ---------------- INVOICE LIST API (from your body) ----------------
  const getInvoiceListApi = useCallback(() => {
    if (!LoginData) return;

    const credentials = {
      userId: LoginData?.userId,
      companyId: LoginData?.companyId,
      accessLevelId: LoginData?.accessLevelId,
      entityListRequestModel: {
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        pageSize: rowsPerPage,
        pageNumber: page + 1,
        sortOrder: order
      },
      filterModel: {
        bankName: invoiceFilterParameter?.bankName ?? null,
        branchName: invoiceFilterParameter?.branchName ?? null,
        status: invoiceFilterParameter?.status ?? null,
        fromDate: invoiceFilterParameter?.fromDate ?? null,
        toDate: invoiceFilterParameter?.toDate ?? null
      }
    };

    dispatch(getInvoiceList(credentials));
  }, [
    LoginData,
    debouncedSearch,
    order,
    rowsPerPage,
    page1,
    dispatch,
    invoiceFilterParameter,
    order,
    rowsPerPage,
    page
    // <-- run whenever invoice filters change
  ]);

  const MasterTypeApi = async () => {
    const fileType = 'REVENUE_FILE_STATUS_TYPE';
    const [fileRes] = await Promise.all([dispatch(getMasterListType(fileType))]);

    const fileStatusOptions = transformToSelectOptions(
      fileRes?.data?.masterTypes || [],
      'typeName',
      'typeId'
    );
    setFileTypeId(fileStatusOptions?.[0]?.value);
  };

  // loan type & Bank Dropdown
  const getLoanTypeBankDropAPi = useCallback(() => {
    if (!LoginData) return;
    const data = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    dispatch(getLoanTypeData(data));
    dispatch(getBankDropdownData(data));
  }, [LoginData, dispatch]);

  useEffect(() => {
    if (tabValue === 0) {
      getReceiveListApi();
    }
  }, [getReceiveListApi, tabValue]);

  useEffect(() => {
    if (tabValue === 1) {
      getInvoiceListApi();
    }
  }, [getInvoiceListApi, tabValue]);

  useEffect(() => {
    getLoanTypeBankDropAPi();
  }, [getLoanTypeBankDropAPi]);

  useEffect(() => {
    MasterTypeApi();
  }, []);

  const isInvoiceNotFound = InvoiceListData.length === 0;
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    defaultValues: {}
  });

  useEffect(() => {
    if (!ReceiveListData) {
      setHasNextPage(true);
      return;
    }
    // If API returned fewer rows → last page
    setHasNextPage(ReceiveListData.length >= rowsPerPage);
  }, [ReceiveListData, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [
    filterName,
    tabValue // tab change
  ]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);
  return (
    <Page title="Partner Management System || Receivable">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Receivable List" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Tabs
            value={tabValue}
            onChange={handleChange}
            className="tabOuter"
            aria-label="basic tabs example"
            classes={{ indicator: 'tabIndicator' }}
          >
            <Tab
              label="Files"
              {...a11yProps(0)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
            />
            <Tab
              label="Invoice"
              {...a11yProps(1)}
              classes={{ selected: 'tabSelected', root: 'tabDefault' }}
            />
          </Tabs>

          {/* ================= FILE TAB ================= */}
          <TabPanel value={tabValue} index={0}>
            <Card>
              <ReceivableFileToolbar
                selected={selected}
                filterParameter={filterParameter}
                setFilterParameter={setFilterParameter}
                setSelected={setSelected}
                filterName={filterName}
                onFilterName={handleFilterByName}
              />

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800, height: '50vh', overflow: 'auto' }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={ReceiveListData.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClickFiles}
                      isCheckBox="true"
                    />
                    <TableBody>
                      {ReceiveListData &&
                        ReceiveListData?.length > 0 &&
                        ReceiveListData?.map((item, index) => {
                          const isItemSelected = selected.indexOf(item) !== -1;
                          return (
                            <StyledTableRow
                              hover
                              key={index}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, item)}
                                />
                              </TableCell>

                              <StyledTableCell align="left">
                                {item?.bankName ? item?.bankName : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.fileNumber ? item?.fileNumber : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.borrowerName ? item?.borrowerName : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.branchName ? item?.branchName : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {isValidValue(item?.fileDisbursedDate)
                                  ? fDate(item?.fileDisbursedDate)
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.loanAmountDisbursed
                                  ? item?.loanAmountDisbursed
                                  : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.loanType ? item?.loanType : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {item?.invoiceId ? item.invoiceId : `${NOT_AVAILABLE}`}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    (item?.misIsMatch === false && 'error') ||
                                    (item?.misIsMatch === true && 'success') ||
                                    'default'
                                  }
                                >
                                  {item.misIsMatch === false
                                    ? 'Mis Matched'
                                    : item.misIsMatch === true
                                    ? 'Matched'
                                    : `${NOT_AVAILABLE}`}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <UserMoreMenu
                                  revenueId={item?.revenueId}
                                  leadId={item?.leadId}
                                  applicationId={item?.applicationId}
                                  recievableData={item}
                                  parent="receivable-file"
                                />
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      {emptyRowsFiles > 0 && (
                        <TableRow style={{ height: 53 * emptyRowsFiles }}>
                          <StyledTableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    {ReceiveListData.length === 0 && (
                      <TableBody>
                        <TableRow>
                          <StyledTableCell
                            align="center"
                            colSpan={TABLE_HEAD.length + 1}
                            sx={{ py: 3 }}
                          >
                            <SearchNotFound searchQuery={filterName} />
                          </StyledTableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
            </Card>
            <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
          </TabPanel>

          {/* ================= INVOICE TAB (API DATA) ================= */}
          <TabPanel value={tabValue} index={1}>
            <Card>
              <ReceivableInvoiceToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
                parent="receivable"
                setFilterParameter={setInvoiceFilterParameter}
              />

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800, overflow: 'auto' }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD_INVOICE}
                      rowCount={InvoiceListData.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClickInvoices}
                      isCheckBox="true"
                    />
                    <TableBody>
                      {InvoiceListData &&
                        InvoiceListData.length > 0 &&
                        InvoiceListData.map((row) => {
                          const isItemSelected = selected.indexOf(row) !== -1;

                          return (
                            <StyledTableRow
                              hover
                              key={row.invoiceId}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, row)}
                                />
                              </TableCell>

                              <StyledTableCell align="left">
                                {row?.invoiceNo || NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.invoiceDate ? fDate(row.invoiceDate) : NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.bankName || NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.branchName || NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.netAmount ?? NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.totalGst ?? NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.partnerPayout ?? NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.partnerName || NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.dueDate ? fDate(row.dueDate) : NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                {row?.duePastDues || NOT_AVAILABLE}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <Label
                                  variant="ghost"
                                  color={
                                    (row?.statusText === 'PENDING' && 'error') ||
                                    (row?.statusText === 'PAID' && 'success') ||
                                    'default'
                                  }
                                >
                                  {row?.statusText
                                    ? sentenceCase(row.statusText.toLowerCase())
                                    : NOT_AVAILABLE}
                                </Label>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <UserMoreMenu
                                  rowId={row?.invoiceId}
                                  parent="receivable-invoice"
                                  statusCode={row?.statusText}
                                  onPayClick={() => {
                                    setSelectedInvoiceId(row.invoiceId);
                                    setOpenPayment(true);
                                  }}
                                  viewUserRow={handleInvoiceDownload}
                                />
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      {/* {emptyRowsInvoice > 0 && (
                          <TableRow style={{ height: 53 * emptyRowsInvoice }}>
                            <StyledTableCell colSpan={6} />
                          </TableRow>
                        )} */}
                    </TableBody>
                    <ReceivableDialogRedux
                      openPayment={openPayment}
                      setOpenPayment={setOpenPayment}
                      userId={LoginData?.userId}
                      invoiceId={selectedInvoiceId}
                      onSuccess={() => {
                        getInvoiceListApi(); // refresh invoices (optional)
                      }}
                    />

                    {isInvoiceNotFound && (
                      <TableBody>
                        <TableRow>
                          <StyledTableCell
                            align="center"
                            colSpan={TABLE_HEAD_INVOICE.length + 1}
                            sx={{ py: 3 }}
                          >
                            <SearchNotFound searchQuery={filterName} />
                          </StyledTableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
            </Card>
            <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
          </TabPanel>
        </Box>

        <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md" fullWidth>
          <DialogTitle>
            Invoice Preview
            <IconButton
              aria-label="close"
              onClick={() => setOpenPreview(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500]
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {previewUrl && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <iframe
                  src={previewUrl}
                  title="Invoice Preview"
                  style={{
                    width: '100%',
                    height: '600px',
                    border: 'none',
                    borderRadius: '4px'
                  }}
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenPreview(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: '1rem' }}>
          <Card>{children}</Card>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
